@if (fields) { @for (item of fields; track $index) {
<mf-template-editor-field [templateDesignFieldDto]="item" />
} }
